import { render, staticRenderFns } from "./service-tile.vue?vue&type=template&id=6b2da9e4&scoped=true&"
import script from "./service-tile.vue?vue&type=script&lang=js&"
export * from "./service-tile.vue?vue&type=script&lang=js&"
import style0 from "./service-tile.vue?vue&type=style&index=0&id=6b2da9e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2da9e4",
  null
  
)

export default component.exports